import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-634a9e82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-records-container" }
const _hoisted_2 = { class: "account" }
const _hoisted_3 = { class: "my-records-tab" }
const _hoisted_4 = { class: "my-records-list" }
const _hoisted_5 = {
  key: 1,
  class: "my-records-list-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chain_tag = _resolveComponent("chain-tag")!
  const _component_account_connect = _resolveComponent("account-connect")!
  const _component_tab = _resolveComponent("tab")!
  const _component_loading = _resolveComponent("loading")!
  const _component_my_record_list = _resolveComponent("my-record-list")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    class: "my-records",
    style: _normalizeStyle(_ctx.phoneStyle)
  }, {
    other: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_chain_tag, { chainId: _ctx.chainIdInit }, null, 8, ["chainId"]),
          _createVNode(_component_account_connect, { address: _ctx.addressInit }, null, 8, ["address"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_tab, {
            active: _ctx.tabActive,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabActive) = $event)),
            lists: _ctx.tabList,
            onChange: _ctx.getRecords
          }, null, 8, ["active", "lists", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loading, {
                key: 0,
                theme: "dark"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.tabActive === 'received')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.receivedList, (data, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "my-records-list-main",
                        key: index
                      }, [
                        _createVNode(_component_my_record_list, {
                          data: data,
                          provider: _ctx.provider,
                          chainId: _ctx.chainIdInit,
                          tokenInfo: _ctx.tokenInfoInit,
                          contractAddress: _ctx.redPackContractAddrInit
                        }, null, 8, ["data", "provider", "chainId", "tokenInfo", "contractAddress"])
                      ]))
                    }), 128))
                  : (_ctx.tabActive === 'sent')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.sentList, (data, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "my-records-list-main",
                          key: index
                        }, [
                          _createVNode(_component_my_record_list, {
                            data: data,
                            provider: _ctx.provider,
                            chainId: _ctx.chainIdInit,
                            tokenInfo: _ctx.tokenInfoInit,
                            contractAddress: _ctx.redPackContractAddrInit,
                            refundSuccessCallback: _ctx.getSent
                          }, null, 8, ["data", "provider", "chainId", "tokenInfo", "contractAddress", "refundSuccessCallback"])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}